// extracted by mini-css-extract-plugin
export default {"flexed":"Flexed_flexed__uLHec","vertical":"Flexed_vertical__5wL5y","between":"Flexed_between__62bu2","centered":"Flexed_centered__UAifd"};